import { daysOfWeek } from "@sellar-io/common";
import dayjs, { Dayjs } from "dayjs";
import { getOrderByDateTime } from "../../pages/order/helpers/DeliveryDateHelpers/getOrderByDate";

export const CourierDeliveryScheduleOrderByContent = ({
  courierDeliveryScheduleEstimations,
  courierDeliverySchedule,
}: {
  courierDeliveryScheduleEstimations:
    | {
        estimatedDispatchDate: Dayjs;
        estimatedDeliveryDate: Dayjs;
      }
    | undefined;
  courierDeliverySchedule: {
    orderCutOffTime: Date;
    dispatchDaysAfterConfirmation: number;
    deliveryDaysAfterDispatch: number;
    CourierDeliveryScheduleDay: { day: daysOfWeek }[];
  };
}) => {
  const courierDeliveryCutoffTime = dayjs(
    courierDeliverySchedule.orderCutOffTime,
  )
    .utc()
    .format("HH:mm");

  const estimatedCourierDelivery =
    courierDeliveryScheduleEstimations?.estimatedDeliveryDate;
  const estimatedCourierDispatch =
    courierDeliveryScheduleEstimations?.estimatedDispatchDate;
  if (!estimatedCourierDelivery || !estimatedCourierDispatch) return;

  const courierDaysCutoff =
    courierDeliverySchedule.dispatchDaysAfterConfirmation;
  const courierScheduleOrderBy = getOrderByDateTime({
    nextDeliveryDate: estimatedCourierDispatch.toDate(),
    orderCutOffTime: courierDeliverySchedule.orderCutOffTime,
    orderCutOffDaysBefore: courierDaysCutoff,
    includeWeekend: true,
  });
  if (!courierDeliveryCutoffTime || !courierScheduleOrderBy) return null;
  return (
    <p>
      Order by <span className={"underline"}>{courierDeliveryCutoffTime}</span>{" "}
      on{" "}
      <span className={"underline"}>
        {courierScheduleOrderBy.format("ddd D MMM")}
      </span>
    </p>
  );
};
